import { VendorBusinessApplication } from '@app/vendor-root-page/vendor-business-application-entry/vendor-business-application-entry.interface';
import { VendorOwnerApplication } from '@app/vendor-root-page/vendor-owner-application-entry/vendor-owner-application-entry.interface';

export interface VddOnboardingRecord {
  id: number;
  companyName: string;
  ein: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  packageType: string;
  createdAt: Date;
  status: 'pending' | 'review' | 'submitted' | 'approved' | 'cancelled' | 'imported';
  extraOwners: { email: string; name: string }[] | null;
  comment?: string;
  extraData?: any;
  orgCode?: string;
  data?: any;
  isArchive: boolean;
}

export function decodeVddOnboardingRecord(data: any): VddOnboardingRecord {
  return {
    id: data.id,
    companyName: data.companyName,
    ein: data.ein,
    contactName: data.contactName,
    contactEmail: data.contactEmail,
    contactPhone: data.contactPhone,
    packageType: data.packageType,
    createdAt: new Date(data.createdAt),
    status: data.status,
    extraOwners: data.extraOwners,
    comment: data.comment,
    extraData: data.extraData,
    orgCode: data.orgCode,
    data: data.data,
    isArchive: data.isArchive,
  };
}

export interface SubmittedOwnerApplicationStatus {
  id: string;
  email: string;
  data: VendorOwnerApplication;
  status: 'submitted';
  candidateId: string;
}

export interface PendingOwnerApplicationStatus {
  email: string;
  status: 'pending';
}

export type OwnerApplicationStatus = SubmittedOwnerApplicationStatus | PendingOwnerApplicationStatus;

export interface BusinessApplicationFormSchema {
  fields: any[];
}

export interface GetApplicationStatus {
  onboarding: VddOnboardingRecord;
  businessApplicationStatus: 'pending' | 'submitted' | 'expired';
  ownerApplications: OwnerApplicationStatus[];
  businessApplication: VendorBusinessApplication | null;
  businessApplicationFormSchema: BusinessApplicationFormSchema | null;
  individualOwners: string[];
  ownerBackgroundCheckTypes: string[];
  businessBackgroundCheckTypes: string[];
}

export function decodeGetApplicationStatus(data: any): GetApplicationStatus {
  return {
    onboarding: decodeVddOnboardingRecord(data.onboarding),
    businessApplicationStatus: data.businessApplicationStatus,
    ownerApplications: data.ownerApplications.map((owner: any) => ({
      email: owner.email,
      status: owner.status,
      data: owner.data,
      id: owner.id,
      candidateId: owner.candidateId,
    })),
    businessApplication: data.businessApplication,
    businessApplicationFormSchema: data.businessApplicationFormSchema,
    individualOwners: data.individualOwners,
    ownerBackgroundCheckTypes: data.ownerBackgroundCheckTypes || [],
    businessBackgroundCheckTypes: data.businessBackgroundCheckTypes || [],
  };
}

export type BackgroundCheckStatus = 'hit' | 'pending' | 'clear' | 'not_started' | 'error' | 'generated';

export interface BackgroundCheckApiResponse {
  apiName: string;
  assessmentDecision: string | null;
  candidateId: string;
  createdOn: Date;
  responseCleanedResult: string;
  assessmentRequestId: number;
}

